/* eslint-disable max-len */
import { template_translation } from '../lang/TemplateTranslation';
const t = template_translation;

/** 12.カラフル */
export const template12 = {
  title: t.to('ランダムブロック', 'title12'),
  desc: t.to(
    'ランダム属性をつかうと物体の配置にランダム性を持たせることができます。ループと組み合わせることで偶発的な面白さを作ることができます。',
    'desc12'
  ),
  img: '../public/template/12.png',
  xml: `
  <xml xmlns="http://www.w3.org/1999/xhtml">
    <variables>
    </variables>
    <block type="a-scene-start" x="30" y="70">
      <statement name="IN">
        <block type="logic_range-loop_v2">
          <field name="COUNTER_VAR">x</field>
          <field name="RANGE_MIN">0</field>
          <field name="RANGE_MAX">100</field>
          <statement name="IN">
            <block type="cube_v2">
              <field name="id">block1</field>
              <field name="position-x">0</field>
              <field name="position-y">1</field>
              <field name="position-z">0</field>
              <value name="COLOUR">
                <shadow type="color_value_v2">
                  <field name="COLOUR">#266e24</field>
                </shadow>
              </value>
              <value name="ATTR">
                <block type="random-position">
                  <value name="ATTR">
                    <block type="random-color">
                    </block>
                  </value>
                </block>
              </value>
            </block>
          </statement>
        </block>
      </statement>
    </block>
  </xml>`,
};
